import { render } from "./ProducerTypes.vue?vue&type=template&id=6844e87a"
import script from "./ProducerTypes.vue?vue&type=script&lang=js"
export * from "./ProducerTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__